module.exports = __webpack_public_path__ + "static/media/html 5.28c92af0.svg";